import React from 'react'
import { Imgix } from '@elements'

export const FullWidthBackgroundImage = ({
  overlapBottom,
  overlapTop,
  backgroundImage,
}) => {
  return (
    <section
      className={`relative z-10
      ${overlapBottom ? `-mb-20 sm:-mb-32 lg:-mb-48 xl:-mb-64` : ``}
      ${overlapTop ? `-mt-5 lg:-mt-12` : ``}
      `}
    >
      <div className="relative overflow-hidden pb-3/6 md:pb-2/6">
        <Imgix
          className="absolute inset-0 object-cover w-full h-full"
          src={backgroundImage.mediaItemUrl}
          alt={backgroundImage.altText}
          sizes="100vw"
        />
      </div>
    </section>
  )
}
